import * as Tone from 'tone';

// Soft-clip distortion. Drive 0-1; oversampled '2x' for a smoother saturation.

export default {
    id: 'distortion',
    name: 'Dist',
    color: '#e06c75',
    create() {
        const node = new Tone.Distortion({ distortion: 0.35, oversample: '2x', wet: 1 });
        return {
            node,
            params: [
                { label: 'Drive', min: 0, max: 1, step: 0.01,
                  get: () => node.distortion, set: v => { node.distortion = v; } },
                { label: 'Wet', min: 0, max: 1, step: 0.01,
                  get: () => node.wet.value, set: v => { node.wet.value = v; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
